export const INTEGRATION_ID = 'vtex';
export const TEST_ID = 'vtex-integration';
export const APPCUES_ID = 'vtex-slot';
export const SLOT_TITLE = 'VTEX';
export const MODAL_TITLE = 'VTEX';
export const MODAL_SUBTITLE_INITIAL = 'Learn how to find your credentials ';
export const MODAL_SUBTITLE_FINAL = 'here';
export const API_TOKEN_LINK = 'https://developers.vtex.com/vtex-developer-docs/docs/getting-started-authentication';

export const API_GET_DATA_URL = '/api/integration/vtex';
export const API_INTEGRATE_URL = '/api/integration/vtex';
export const API_SUCCESS_OP_MESSAGE = 'Api Token Successfully Saved.';
export const API_FAIL_DEFAULT_OP_MESSAGE = 'Unknown Error';

export const FIELDS = {
    ACCOUNT_NAME: {
        LABEL: 'Account Name',
        NAME: 'accountName',
        PLACEHOLDER: 'Edit Account Name here',
        TEST_ID: 'vtex-modal-input-account-name',
    },
    APP_KEY: {
        LABEL: 'App Key',
        NAME: 'appKey',
        PLACEHOLDER: 'ck_123456789',
        TEST_ID: 'vtex-modal-input-app-key',
    },
    APP_TOKEN: {
        LABEL: 'App Token',
        NAME: 'appToken',
        PLACEHOLDER: 'cs_123456789',
        TEST_ID: 'vtex-modal-input-app-token',
    },
};
